<template>
  <div class="form">
    <iframe
      id="iframe"
      :src="`${h5_url}/#/pages/show?type=pc&id=${$route.params.id}&form=${$route.query.form_id}`"
      frameborder="0"
      width="100%"
      style="height: 100vh; width: 520px"
      scrolling="no"
      title=""
    ></iframe>
    <!-- 流程 -->
  </div>
</template>
<style lang="less" scoped>
.form {
}
</style>
<script>
import { mapState } from 'vuex';
import app_config from '@/commons/app_config';
import { AuthManage } from '@/plugins/auth';

export default {
  data() {
    return {
      h5_url: app_config.h5_url,
      post_web_data: {
        platform: `${
          process.env.VUE_APP_REGION === 'yoov' ? 'yoov' : 'lanku'
        }_${process.env.NODE_ENV === 'production' ? '' : 'dev'}`,
        short_name: 'Hk',
        theme: 'light',
        token: null,
        id: null,
        i18n: 'hk',
        teamId: null,
        leaveId: null,
        formId: null,
        actualWorkingClassTime: null
      }
    };
  },
  computed: {
    ...mapState(['self'])
  },
  mounted() {
    this.sendMsg();
  },
  methods: {
    sendMsg() {
      let iframe = document.getElementById('iframe');
      iframe.onload = () => {
        this.post_web_data.token = {
          token_type: 'bearer',
          access_token: AuthManage.token,
          id_token: AuthManage.idToken,
          expires_in: AuthManage.expiresAt,
          refresh_token: AuthManage.refreshToken
        };
        this.post_web_data.teamId = localStorage.getItem('teamId');
        this.post_web_data.id = this.$route.params.id;
        this.post_web_data.from = this.$route.query.from;
        this.post_web_data.i18n = this.$i18n.locale;
        iframe.contentWindow.postMessage(
          JSON.stringify(this.post_web_data),
          `${this.h5_url}/#/pages/show`
        );
      };
    }
  }
};
</script>
